require('./pageicon');
require('./useractivity');

let Settings = require('./settings');

let Notifier = {
	notificationIcon: '/res/i/cloud.svg',

	playSound(){
		if (Settings.sound){
			let $a = Chat.$root.find('audio.chat-audio-notification');
			if ($a.length > 0 && $a[0].play){
				$a[0].play();
			}
		}
	},

	rollIcon(){
		if (Settings.icon){
			PageIcon.startRolling();
		}
	},

	showNotification(title, body){
		if (Settings.isNotificationPermissionGranted()){
			let n = new Notification(title, {
				body: body.substr(0, 128),
				icon: this.notificationIcon,
			});
			setTimeout(n.close.bind(n), 6000);
		}
	},

	message(room, login, msg){
		if (!UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.notifyAll){
				this.showNotification('[' + room + '] ' + login, msg);
			}
		}
	},

	online(room, login, msg){
		if (!UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.notifyAll){
				this.showNotification('[' + room + ']', login + ' ' + msg);
			}
		}
	},

	mention(room, login, msg){
		if (!UserActivity.isUserActive()){
			this.playSound();
			this.rollIcon();
			if (Settings.mention){
				this.showNotification('[' + room + '] ' + login, msg);
			}
		}
	},
};

module.exports = Notifier;
